export function getAppId() {
  return parseFloat(process.env.REACT_APP_ID)
}

export function getAnalyticsId() {
  return process.env.REACT_APP_ANALYTICS_ID
}

export function getArcGISAPIKey() {
  return process.env.REACT_APP_ARCGIS_API_KEY
}

export function getDisclaimer() {
  return window.env.REACT_APP_DISCLAIMER
}

export function getGeoServerUrl() {
  return window.env.REACT_APP_GEOSERVER_URL
}

export function getFewsWebServicesUrl() {
  return window.env.REACT_APP_FEWS_WEBSERVICES_URL
}

export function getRainsatProxyApiUrl() {
  return window.env.REACT_APP_RAINSAT_PROXY_API_URL
}

export function getSupportEmail() {
  return window.env.REACT_APP_SUPPORT_EMAIL
}